import { Modal } from 'carbon-components';
import { Component } from '@verndale/core';

class Module extends Component {
  constructor(el: HTMLElement) {
    super(el);
    Modal.create(this.modal);
  }

  setupDefaults() {
    this.modal = this.el.parentNode.querySelector(
      this.el.dataset.econtractingModal
    );
    this.state = this.modal?.classList.contains('is-visible');
    this.continueLink = this.modal?.querySelector('[data-modal-primary-focus]');
  }

  addListeners() {
    this.el.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (!this.modal.classList.contains('is-visible')) {
      this.modal.classList.add('is-visible');
      this.continueLink.focus();
    }
  }
}

export default Module;
